module.exports = __webpack_public_path__ + "img/generated-1772416024977.8977c577.png";